import script from "./ConsultaPsicologica.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultaPsicologica.vue?vue&type=script&setup=true&lang=js"

import "./ConsultaPsicologica.vue?vue&type=style&index=0&id=e6232f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6232f54"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpace,QBtn,QBtnGroup,QTooltip,QTabs,QTab,QSpinnerDots,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {Ripple});
